
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import type { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import StaticPageTemplate from '@/components/StaticTemplate';
import { AccountManager } from '@/components/AccountManager';
import { ContactUsForm } from '@/components/Form/ContactUsForm';
import type { AccountManager as AccountManagerType } from '@/lib/types/bevmaq.types';
import {
  getAccountManagerByLocale,
  getCountries,
} from '@/lib/utilities/repository';
import { SWRConfig } from 'swr';

function ProfileContact({
  title,
  name,
  phone,
  email,
}: {
  title: string;
  name: string;
  phone: string;
  email: string;
}) {
  return (
    <div className='flex flex-col items-center border-2 p-4 shadow-md'>
      <h4 className='font-semibold uppercase'>{title}:</h4>
      <h4>{name}</h4>
      <a href={'tel:' + phone} className='link'>
        {phone}
      </a>
      <a href={'mailto:' + email} className='link block'>
        {email}
      </a>
    </div>
  );
}

function ContactPage({
  accountManager,
  fallback,
}: {
  accountManager: AccountManagerType;
  fallback: any;
}) {
  const { t } = useTranslation();
  const title = t('common:contact.title-subheader');
  const subtitle =
    t('common:contact.title-header') + ' ' + t('common:contact.form-subtitle');
  const components = [
    <SWRConfig value={{ fallback }} key='swrConfig'>
      <div className='flex flex-col items-center bg-white'>
        <div className='max-w-7xl'>
          <Hero accountManager={accountManager} />
        </div>
        <AccountManager
          accountManager={accountManager}
          containerClasses='bg-white'
        />
      </div>
    </SWRConfig>,
  ];

  return (
    <StaticPageTemplate
      title={title}
      subtitle={subtitle}
      components={components}
    />
  );
}

function Hero({ accountManager }: { accountManager: AccountManagerType }) {
  const { t } = useTranslation();
  return (
    <div className='flex w-full flex-col justify-around'>
      <div className='grid grid-cols-1 gap-8 bg-white md:grid-cols-6'>
        <div className='flex flex-col space-y-8 md:col-span-4'>
          <h1
            data-testid='header-title'
            className='text-center text-2xl font-semibold text-black'
          >
            {t('contact.send us a message')}
          </h1>
          <div className='flex flex-col justify-center space-y-4 rounded px-6 py-8'>
            <ContactUsForm />
          </div>
        </div>
        <div className='flex flex-col space-y-8 md:col-span-2'>
          <h3 className='text-center text-2xl font-semibold text-black'>
            {t('common:Call us or send us an email')}
          </h3>
          <ContactInformation accountManager={accountManager} />
        </div>
      </div>
    </div>
  );
}

function ContactInformation({
  accountManager,
}: {
  accountManager: AccountManagerType;
}) {
  const { t } = useTranslation();
  return (
    <div className='mb-8 space-y-8'>
      <div className='flex flex-col space-y-6 '>
        <ProfileContact
          title={t('common:Selling machines')}
          name={accountManager.name}
          email='sell@bevmaq.com'
          phone={accountManager.phone}
        />
        <ProfileContact
          title={t('common:Buying Machines')}
          name={accountManager.name}
          email='buy@bevmaq.com'
          phone={accountManager.phone}
        />
        <ProfileContact
          title={t('common:Jobs')}
          name='Carsten Hormes'
          email='jobs@bevmaq.com'
          phone='+49 173 90 80 414'
        />
        <ProfileContact
          title={t('common:Press and Media')}
          name='Benedikt Ruf'
          email='press@bevmaq.com'
          phone='+49 173 273 1973'
        />
      </div>
    </div>
  );
}

 const _getStaticProps: GetStaticProps = async ({ locale }) => {
  const accountManager = await getAccountManagerByLocale(locale);
  return {
    props: {
      hasContainer: false,
      accountManager: accountManager,
      fallback: {
        [`/api/countries/${locale}`]: await getCountries(locale),
      },
    },
  };
};

export default ContactPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/contact',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  